import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d2797d2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=6d2797d2&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=6d2797d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2797d2",
  null
  
)

export default component.exports